// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ovdAE","questions":"styles_questions__3KoMV","footer":"styles_footer__2XQMm"};